import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

export interface IConfirmPlanChangePayload {
  plan_id: number;
}

export interface IConfirmPlanChangeResponse {
  message: string;
  status: string;
}

export const useConfirmPlanChange = () => {
  const queryClient = useQueryClient();
  const { refreshUser } = useAuth();

  return useMutation<IConfirmPlanChangeResponse, Error, IConfirmPlanChangePayload>({
    mutationFn: async (payload) =>
      httpService.post<IConfirmPlanChangeResponse>(
        API_CONFIG.path.stripeConfirmPlanChange,
        payload as unknown as Record<string, unknown>
      ),
    onSuccess: () => {
      refreshUser();
      queryClient.invalidateQueries({ queryKey: ["stripe", "history"] });
    },
  });
};
